module.exports = "https://lts-static.prod-my.games/promo/lp1/img/arrow.239d89d0.svg";